import { setRequiredChain } from '../slices/portal.slice'
import type { AppDispatch } from '../configureStore'

export const requireChain = (dispatch: AppDispatch) => async (chainName: string) => {
  return new Promise<{ done: boolean; reason?: string }>((resolve, reject) => {
    dispatch(
      setRequiredChain({
        requiredChain: {
          chainName,
          resolve,
          reject,
        },
      }),
    )
  })
}

export const clearRequiredChain = (dispatch: AppDispatch) => () => {
  dispatch(
    setRequiredChain({
      requiredChain: null,
    }),
  )
}
